$(document).ready(function(){
  $('.condition_popup_btn').click(function(){
    $('.condition_popup_main').addClass('open');
    $('#shopify-section-header').addClass('reduce_index');
    $('body').addClass('stop_scroll');
  });
  $('.close_condition_popup').click(function(){
    $('.condition_popup_main').removeClass('open');
    $('#shopify-section-header').removeClass('reduce_index');
    $('body').removeClass('stop_scroll');
  });
  $('.condition_popup_main').click(function(e){
    if (e.target === this) {  
        $('.condition_popup_main').removeClass('open');
        $('#shopify-section-header').removeClass('reduce_index');
        $('body').removeClass('stop_scroll');
    }
   });
  // newsletter js start
    var newsletterCookie = $.cookie('Newsletter_hide'); 
    let currentLocation = window.location.href;
    if(currentLocation.includes('#newsletter')){
      $('body').addClass('hide_footer_news_message');
      $.cookie('Newsletter_hide', 'true', { expires: 1, path: '/' }); 
    }else {
      if (!newsletterCookie) {
      setTimeout(function(){
      $('.newsletter_popup_main').addClass('open');
      $('body').addClass('stop_scroll');
    }, 5000);
    } 
    }
    
      
    $('.close_newsletter').click(function() {
      $('.newsletter_popup_main').removeClass('open');
      $('body').removeClass('stop_scroll');
      $.cookie('Newsletter_hide', 'true', { expires: 1, path: '/' }); 
    });

    $('.newsletter_popup_main').click(function(e){
    if (e.target === this) {  
        $('.newsletter_popup_main').removeClass('open');
        $('body').removeClass('stop_scroll');
        $.cookie('Newsletter_hide', 'true', { expires: 1, path: '/' }); 
    }
   });
   $('.newsletter_popup .newsletter_top .second_text').click(function(){
       $(this).hide();
       $('.newsletter_popup .no_thanks').hide();
       $('.newsletter_popup .form_box').fadeIn();
       $('.newsletter_top_inner').addClass('newsletter_top_inner_pb_80');
   }); 
  $('.newsletter_popup .no_thanks span').click(function(){
     $(".newsletter_popup .newsletter_top span.close_newsletter").trigger("click");
  });
// newsletter js end


});